<template>
  <div class="box">
    <div class="register">
      <p class="title">开通学校服务 | Opening</p>
      <div>
        <p class="inputT">您的姓名：</p>
        <el-input
          clearable
          placeholder="请输入您的姓名"
          v-model="inputname"
          size="small"
          @input="handlename"
          @blur="handlename"
        >
        </el-input>
        <div class="tip" v-show="isname">{{ tipsname }}</div>
      </div>
      <div>
        <p class="inputT">您的手机：</p>
        <el-input
          clearable
          placeholder="请输入手机号"
          v-model="input1"
          size="small"
          @input="hh1"
          @blur="hh1"
        >
        </el-input>
        <div class="tip" v-show="isone">{{ tips1 }}</div>
      </div>
      <div>
        <p class="inputT">验证码：</p>
        <el-input
          clearable
          size="small"
          placeholder="请输入验证码"
          v-model="input9"
          class="code"
          @input="hh9"
          @blur="hh9"
        >
        </el-input>
        <el-button
          size="small"
          :disabled="disabled"
          type="primary"
          @click="getCode"
          >{{ codenum }}</el-button
        >
        <div class="tip" v-show="iscode">{{ tips9 }}</div>
      </div>
      <div>
        <p class="inputT">学校名称：</p>
        <el-input
          clearable
          placeholder="请输入学校名称"
          v-model="input2"
          size="small"
          @input="hh2"
          @blur="hh2"
        >
        </el-input>
        <div class="tip" v-show="istwo">{{ tips2 }}</div>
      </div>
      <div>
        <p class="inputT">您的职位：</p>
        <el-input
          clearable
          placeholder="请输入您的职位"
          v-model="input3"
          size="small"
          @input="hh3"
          @blur="hh3"
        >
        </el-input>
        <div class="tip" v-show="isthree">{{ tips3 }}</div>
      </div>
      <div>
        <p class="inputT">所在地区：</p>
        <!-- <el-input
          clearable
          placeholder="请输入省/市/区"
          v-model="input4"
          size="small"
          @input="hh4"
          @blur="hh4"
        >
        </el-input> -->
        <el-cascader
          size="small"
          :options="options_"
          v-model="selectedOptions"
          @change="handleChange"
          placeholder="请选择学校所在地区"
        ></el-cascader>
        <!-- <div class="tip" v-show="isfour">{{ tips4 }}</div> -->
      </div>

      <div>
        <p class="inputT">备注：</p>
        <el-input
          clearable
          placeholder="请输入备注"
          v-model="remarks"
          size="small"
        ></el-input>
      </div>

      <div class="clearfix" style="margin: 10px 0">
        <el-checkbox
          v-model="checked"
          style="margin-top: 10px; margin-right: 60px"
          @change="hh6"
          >提交申请即同意《用户服务协议》</el-checkbox
        >
        <div class="tip" v-show="issix">请阅读并同意我们的服务条款</div>
      </div>
      <div class="clearfix" style="height: 50px; line-height: 50px">
        <el-button
          type="primary"
          class="fl"
          style="width: 100%; margin-top: 10px"
          @click="handleReg"
          >提交申请</el-button
        >
      </div>
    </div>
    <div class="bottom">
      <p>版权及最终解释权归山东大课堂信息技术有限公司所有</p>
      <p>
        Copy right@2018 山东大课堂信息技术有限公司 all Rights Reserved 版权所有
      </p>
    </div>
  </div>
</template>

<script>
import URL from "../../api/index";
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode,
} from "element-china-area-data";
export default {
  data() {
    return {
      options_: regionData,
      selectedOptions: [],
      infoForm: { province: "", city: "", area: "" },
      inputname: "",
      input1: "",
      input2: "",
      input9: "",
      input3: "",
      input4: "",
      checked: true,
      tipsname: "请输入您的姓名",
      isname: false,
      tips1: "请输入手机号",
      tips2: "请输入学校名称",
      tips3: "请输入您的职位",
      tips4: "请输入省/市/区",
      tips9: "请输入验证码",
      issix: false,
      isfour: false,
      isthree: false,
      istwo: false,
      isone: false,
      iscode: false,
      disabled: false,
      codenum: "获取验证码",
      countdown: 60,
      remarks: "",
    };
  },
  components: {},
  mounted() {
    var userinfo = JSON.parse(localStorage.getItem("loginInfo"));
    this.inputname = userinfo.user_nicename;
    this.input1 = userinfo.mobile;
    this.input3 = userinfo.level;
  },
  methods: {
    hh1() {
      if (!this.input1) {
        this.isone = true;
      } else {
        this.isone = false;
        var re = /^(((13[0-9])|(14[5-7])|(15[0-9])|(17[0-9])|(18[0-9]))+\d{8})$/;
        if (re.test(this.input1)) {
          this.isone = false;
        } else {
          this.isone = true;
          this.tips1 = "请输入正确格式的手机号";
        }
      }
    },
    hh2() {
      if (!this.input2) {
        this.istwo = true;
      } else {
        this.istwo = false;
      }
    },
    hh3() {
      if (!this.input3) {
        this.isthree = true;
      } else {
        this.isthree = false;
      }
    },
    hh4() {
      if (!this.input4) {
        this.isfour = true;
      } else {
        this.isfour = false;
      }
    },
    handlename() {
      if (!this.inputname) {
        this.isname = true;
      } else {
        this.isname = false;
      }
    },
    hh9() {
      if (!this.input9) {
        this.iscode = true;
      } else {
        this.iscode = false;
      }
    },
    hh6() {
      if (!this.checked) {
        this.issix = true;
      } else {
        this.issix = false;
      }
    },
    getCode() {
      var data_code = {
        mobile: this.input1,
      };
      if (!this.input1) {
        this.isone = true;
      }
      if (!this.isone) {
        this.$post(URL.getvcode, data_code).then((res) => {
          console.log(res);
          if (res.state == 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });

            this.timer();
          } else {
            this.$message(res.msg);
          }
        });
      }
    },
    timer() {
      if (this.countdown > 0) {
        this.disabled = true;
        this.countdown--;
        this.codenum = "重新发送(" + this.countdown + ")";
        setTimeout(this.timer, 1000);
      } else {
        this.countdown = 0;
        this.codenum = "获取验证码";
        this.disabled = false;
      }
    },
    handleChange(res) {
      var self = this;
      var provinceCode = self.selectedOptions[0];
      var cityCode = self.selectedOptions[1];
      var areaCode = self.selectedOptions[2];
      // CodeToText属性是区域码，属性值是汉字 CodeToText['110000']输出北京市
      self.infoForm.province = CodeToText[provinceCode];
      self.infoForm.city = CodeToText[cityCode];
      self.infoForm.area = CodeToText[areaCode];
      // console.log(
      //   self.infoForm.province,
      //   self.infoForm.city,
      //   self.infoForm.area
      // );
    },
    handleReg() {
      var data = {
        token: JSON.parse(localStorage.getItem("loginInfo")).token,
        school_name: this.input2,
        user_name: this.inputname,
        role_name: this.input3,
        mobile: this.input1,
        area:
          this.infoForm.province +
          "/" +
          this.infoForm.city +
          "/" +
          this.infoForm.area,
        remark: this.remarks,
        type: "smartclass",
        code: this.input9,
      };
      if (!this.input1) {
        this.isone = true;
      }
      if (!this.input2) {
        this.istwo = true;
      }
      if (!this.input3) {
        this.isthree = true;
      }
      if (!this.inputname) {
        this.isname = true;
      }
      if (!this.input9) {
        this.iscode = true;
      }

      if (!this.selectedOptions.length) {
        this.$message("请选择学校地区");
        return false;
      }

      if (
        !this.isone &&
        !this.istwo &&
        !this.isthree &&
        !this.isname &&
        !this.iscode
      ) {
        console.log(data);
        this.$post(URL.getSchoolapply, data).then((res) => {
          console.log(res);
          if (res.state == 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.$router.push("/home");
          } else {
            this.$message(res.msg);
          }
        });
      }
    },
  },
};
</script>

<style lang='less' scoped>
.box {
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url("../../assets/login_img.png");
  background-position: 0 -100px;

  .register {
    z-index: 12;
    border-radius: 8px;
    background-color: #fff;
    position: absolute;
    top: 8%;
    right: 15%;
    padding: 30px 40px;
    .title {
      font-size: 26px;
      color: #1890ff;
      font-weight: 700;
      margin-top: 10px;
      margin-bottom: 20px;
    }
  }
  .inputT {
    padding-top: 10px;
    padding-bottom: 6px;
  }
  .tip {
    font-size: 12px;
    color: red;
  }
  .el-checkbox /deep/ .el-checkbox__label {
    font-size: 12px !important;
  }
  .btn {
    font-size: 12px !important;
    cursor: pointer;
    margin-top: 5px;
    color: #639edd;
  }
  .el-input {
    width: 340px;
    margin: 6px 0;
  }

  .code {
    width: 220px;
    margin-right: 30px;
  }

  .bottom {
    position: absolute;
    text-align: center;
    bottom: 40px;
    left: 40%;
    color: #fff;
    font-size: 12px;
    p {
      margin-bottom: 20px;
    }
  }
}
</style>
